import { mapState } from 'vuex'
import Modal from '@/components/modals/modal/modal.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import FiltersSelect from '@/components/filters-select/filters-select.vue'
import CurrencyFormatInput from '@/components/currency-format-input/currency-format-input.vue'

const getDefaultForm = () => ({
  description: '',
  payment_type: null,
  amount: 0
})

export default {
  name: 'AdjustmentModal',
  components: {
    Modal,
    ValidationObserver,
    ValidationProvider,
    FiltersSelect,
    CurrencyFormatInput
  },
  props: {
    /**
     * {
     *   description,
     *   payment_type,
     *   amount,
     *   adjustment_id
     * }
     */
    editedAdjustment: {
      type: Object
    }
  },
  data() {
    return {
      form: getDefaultForm()
    }
  },
  computed: {
    ...mapState({
      paymentTypes: state => {
        const paymentTypes = state.sharedData.paymentTypes
        return Object.keys(paymentTypes).map(key => ({
          id: key,
          title: paymentTypes[key].title
        }))
      }
    })
  },
  methods: {
    show () {
      this.form = getDefaultForm()
      if (this.editedAdjustment) {
        Object.keys(this.form).forEach(key => {
          if (key === 'payment_type') {
            this.form[key] = this.paymentTypes.find(typeObj => typeObj.id === this.editedAdjustment[key])
          } else {
            this.form[key] = this.editedAdjustment[key]
          }
          
        })
      }
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    onSubmit() {
      this.$refs['observer'].validate().then(async success => {
        if (success) {
          const sendData = { ...this.form }
          sendData.payment_type = sendData.payment_type.id
          if (this.editedAdjustment) {
            this.$emit('edit-adjustment', {
              ...sendData,
              adjustment_id: this.editedAdjustment.adjustment_id
            })
          } else {
            this.$emit('add-adjustment', {
              ...sendData
            })
          }
        }
      })
    }
  }
}